const signalR = require('@microsoft/signalr');

let counter = 0;

export function fastStartHubPromise(urlHub, hubName) {
  console.debug('fastStartHubPromise url: ', urlHub, ' hub name: ', hubName);
  return new Promise((resolve, reject) => {
    const RECONNECTING_TIME_INTERVAL = [0, 1000, 2000, 3000, 4000, 5000];
    const hub = new signalR.HubConnectionBuilder()
      .withUrl(`${urlHub}/hub/${hubName}`, {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
      })
      .withAutomaticReconnect(RECONNECTING_TIME_INTERVAL)
      .build();
    hub.serverTimeoutInMilliseconds = 30000;
    hub
      .start()
      .then(() => {
        counter = 0;
        resolve(hub);
      })
      .catch((err) => {
        if (counter < 3) {
          counter += 1;
          setTimeout(() => fastStartHubPromise(urlHub, hubName), 6000);
        }
        reject(err);
      });
  });
}

export function fastStopHubPromise(hub, hubName) {
  console.debug('fastStopHubPromise hub name: ', hubName);
  return new Promise((resolve, reject) => {
    hub
      .stop()
      .then(() => {
        resolve(hub);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

const doFastInvokeAPIPromise = (isSilent, hub, ApiName, ...ApiParam) =>
  new Promise((resolve, reject) => {
    if (isSilent) {
      console.debug('fastInvokeAPIPromise start invoke', ApiName);
    } else {
      console.debug('fastInvokeAPIPromise start invoke', ApiName, 'with param:', ...ApiParam);
    }

    hub
      .invoke(ApiName, ...ApiParam)
      .then((response) => {
        console.debug('fastInvokeAPIPromise', ApiName, 'response', response);
        resolve(response);
      })
      .catch((err) => {
        console.debug('fastInvokeAPIPromise', ApiName, err);
        reject(err);
      });
  });

export function fastInvokeAPIPromise(hub, ApiName, ...ApiParam) {
  return doFastInvokeAPIPromise(false, hub, ApiName, ...ApiParam);
}

export function fastSilentInvokeAPIPromise(hub, ApiName, ...ApiParam) {
  return doFastInvokeAPIPromise(true, hub, ApiName, ...ApiParam);
}
